import { AdapterState } from '@tronweb3/tronwallet-abstract-adapter';
import React from 'react';
import { Button } from './Button.js';
export const WalletItem = ({ onClick, wallet }) => {
    return (React.createElement("div", { className: "adapter-wallet-item" },
        React.createElement(Button, { onClick: onClick, icon: wallet.adapter.icon, tabIndex: 0 },
            wallet.adapter.name,
            React.createElement("span", { className: "status-text" }, wallet.state !== AdapterState.NotFound ? 'Detected' : 'NotFound'))));
};
//# sourceMappingURL=WalletItem.js.map